import React, { useEffect, useState } from "react";
import apiClient from "../api/apiClient";

const PendingRides = () => {
  const [rides, setRides] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchPendingRides = async () => {
    setLoading(true);

    try {
      const token = localStorage.getItem("token");

      const res = await apiClient.get("/admin/pending", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setRides(res.data);
    } catch (err) {
      console.log(err);
      alert("Failed to load pending rides");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingRides();
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    return d.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h2 style={{ marginBottom: "20px" }}>Pending Rides</h2>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              minWidth: "1800px",
              fontSize: "13px",
            }}
          >
            <thead>
              <tr style={{  color: "#111" }}>
                <th style={th}>ID</th>
                <th style={th}>User ID</th>
                <th style={th}>Pickup Address</th>
                <th style={th}>Drop Address</th>
                <th style={th}>Sender House</th>
                <th style={th}>Sender Name</th>
                <th style={th}>Sender Phone</th>
                <th style={th}>Receiver House</th>
                <th style={th}>Receiver Name</th>
                <th style={th}>Receiver Phone</th>
                <th style={th}>Vehicle Info</th>
                <th style={th}>Final Fare</th>
                <th style={th}>Driver ID</th>
                <th style={th}>Created At</th>
              </tr>
            </thead>

            <tbody>
              {rides.map((ride) => (
                <tr key={ride.id}>
                  <td style={td}>{ride.id}</td>
                  <td style={td}>{ride.userId}</td>
                  <td style={td}>{ride.pickupAddress}</td>
                  <td style={td}>{ride.dropAddress}</td>
                  <td style={td}>{ride.senderHouse}</td>
                  <td style={td}>{ride.senderName}</td>
                  <td style={td}>{ride.senderPhone}</td>
                  <td style={td}>{ride.receiverHouse}</td>
                  <td style={td}>{ride.receiverName}</td>
                  <td style={td}>{ride.receiverPhone}</td>
                  <td style={td}>{ride.vehicleInfo}</td>
                  <td style={td}>₹{ride.finalFare}</td>
                  <td style={td}>{ride.driverId || "-"}</td>
                  <td style={td}>{formatDate(ride.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PendingRides;

/* ================= STYLE ================= */

const th = {
  padding: "10px",
  border: "1px solid #ddd",
  textAlign: "left",
  whiteSpace: "nowrap",
};

const td = {
  padding: "10px",
  border: "1px solid #ddd",
  whiteSpace: "nowrap",
};